import { useEffectOnceWhen } from '@utils/useEffectOnceWhen'

export function useTrackGtmPageView(): void {
    useEffectOnceWhen(() => {
        window._gtm.push({
            event: 'page_view',
            page_location: document.location.href,
            page_title: document.title,
            page_path: document.location.pathname,
            isGAEvent: 1,
        })
    }, true)
}
